import { connect } from 'react-redux';
import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import './CreateService.css';
import CloseIcon from '@mui/icons-material/Close';
import { createService, editService, fetchServiceDetails } from '../../store/app/apis';
import Toast from 'light-toast';

function CreateService({ serviceList, createService, editService, projectList, fetchServiceDetails, ...props }) {
  const [anchorEl, setAnchorEl] = useState(props.anchorEl);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    name: '',
    env: '',
    project: '',
    stype: '',
    host: '',
  });

  const cancelPop = () => {
    setAnchorEl(null);
    props.onClose();
  };

  const handleNameChange = (e) => {
    if (e.target.value?.length && isNaN(e.target.value.charAt(0)) === false) {
      return;
    }
    setState((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };
  const handleHostChange = (e) => {
    setState((prev) => ({
      ...prev,
      host: e.target.value,
    }));
  };
  const handleServiceTypeChange = (e) => {
    setState((prev) => ({
      ...prev,
      stype: e.target.value,
    }));
  };
  const handleEnvironmentChange = (e) => {
    setState((prev) => ({
      ...prev,
      env: e.target.value,
    }));
  };

  const handleProjectChange = (event) => {
    setState((prev) => ({
      ...prev,
      project: event.target.value,
    }));
  };

  // Handling the form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (state?.name === '' || state?.env === '' || state?.project === '') {
      Toast.fail('Please enter all details!');
    } else {
      if (props.id) {
        editService({
          id: props.id,
          env: state?.env,
          name: state?.name,
          project: state?.project,
          host: state?.host,
          stype: state?.stype,
        }).then((res) => {
          setState((prev) => ({
            ...prev,
            name: '',
            env: '',
            project: '',
            host: '',
            stype: '',
          }));
          cancelPop();
        });
        return;
      }
      createService({
        env: state?.env,
        name: state?.name,
        project: state?.project,
        host: state?.host,
        stype: state?.stype,
      }).then((res) => {
        setState((prev) => ({
          ...prev,
          name: '',
          env: '',
          project: '',
          host: '',
          stype: '',
        }));
        cancelPop();
      });
    }
  };

  useEffect(() => {
    if (!props.id) return;
    if (serviceList?.length !== 0) setState(serviceList?.find((service) => service.id === props.id));
    else {
      fetchServiceDetails(props.id).then((res) => {
        setState(res);
      });
    }
  }, [props.id]);

  useEffect(() => {
    setAnchorEl(props.anchorEl);
  }, [props.anchorEl]);

  return (
    <>
      <Dialog id="create-popover" open={open} onClose={cancelPop}>
        <Box
          sx={{
            padding: '20px',
            paddingTop: '10px',
          }}
        >
          <div className="formTitle">
            <h3 className="serviceform">Service Form </h3>
            <CloseIcon onClick={cancelPop} sx={{ cursor: 'pointer' }} />
          </div>

          <form>
            <div className="forminput">
              <label>Enter Name</label>
              <span className="redstar">*</span>
              <TextField
                id="outlined-basic"
                onChange={handleNameChange}
                placeholder="Title"
                value={state?.name}
                variant="outlined"
              />
            </div>
            <div className="forminput">
              <label>Select Environment </label>
              <span className="redstar">*</span>
              <FormControl sx={{ display: 'flex', minWidth: 140, backgroundColor: 'white' }} size="small">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={state?.env}
                  onChange={handleEnvironmentChange}
                >
                  <MenuItem value="dev">DEV</MenuItem>
                  <MenuItem value="stg">STAGE</MenuItem>
                  <MenuItem value="prod">PROD</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="forminput">
              <label>Select Project</label>
              <span className="redstar">*</span>
              <FormControl sx={{ display: 'flex', minWidth: 140, backgroundColor: 'white' }} size="small">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={state?.project}
                  onChange={handleProjectChange}
                >
                  {projectList?.map((project) => (
                    <MenuItem key={project?.id} value={project?.id}>
                      {project?.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="forminput">
              <label>Enter Host</label>
              <TextField
                id="outlined-basic"
                onChange={handleHostChange}
                placeholder="Host"
                value={state?.host}
                variant="outlined"
              />
            </div>
            <div className="forminput">
              <label>Enter Service Type</label>
              <TextField
                id="outlined-basic"
                onChange={handleServiceTypeChange}
                placeholder="ServiceType"
                value={state?.stype}
                variant="outlined"
              />
            </div>
            <div className="buttonscancel">
              <button onClick={cancelPop}>Cancel</button>
              <button onClick={handleSubmit}>{props.id ? 'Edit' : 'Add'}</button>
            </div>
          </form>
        </Box>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  projectList: state.app.projectList,
  serviceList: state.app.serviceList,
});

const mapDispatchToProps = { fetchServiceDetails, createService, editService };

export default connect(mapStateToProps, mapDispatchToProps)(CreateService);
